import { useAuth0 } from "~/composables/useAuth0";

export default defineNuxtRouteMiddleware((to) => {
  return useAuth0().ensureAuthenticated(to);
});
